import DefaultPlayer from './defaultPlayer'
import { getMimetype } from '../utils/media_tools'

export default class WebosPlayer extends DefaultPlayer {
  constructor(mediaElement, manifestUrl) {
    super(mediaElement, manifestUrl)

    this.playerName_ = "Webos-Player"

    /** @private */
    this.defaultConfig_ = {}
    this.webosConfig_ = {}

    this.appId = "com.spotv.app.dev"
    this.devideId = null
    this.clientId = null
  }

  initialize() {
    const source = document.createElement("source");
    
    let mediaOption = ";mediaOption=" + encodeURIComponent(JSON.stringify(this.webosConfig_))
    let mimeType = getMimetype(this.manifestUrl_)
    
    source.setAttribute("src", this.manifestUrl_)
    source.setAttribute("type", mimeType + mediaOption)
    
    this.mediaElement_.appendChild(source)
    return this.load()
  }

  configure(defaultConfig) {
    const webosConfig = {}

    webosConfig.option = {}
    webosConfig.option.adaptiveStreaming = {}
    webosConfig.option.adaptiveStreaming.apativeResolution = true
    webosConfig.option.adaptiveStreaming.seamlessPlay = true

    if (defaultConfig['drm']) {
      // webosConfig.option.mediaTransportType = "WIDEVINE"

      this.createDrmClient().then((response) => {
        webosConfig.option.drm = {}
        webosConfig.option.drm.type = 'playready'
        webosConfig.option.drm.clientId = response.clientId
        // webosConfig.option.drm.widevine = {}
        
        const {licenseUrl, token} = defaultConfig['widevine']
        if (webosConfig.option.drm.type == 'widevine') {
          this.widevineMessage(response.clientId, licenseUrl, token)
        } else {
          this.parsePlayready(response.clientId, licenseUrl, token)
        }
      })
    }

    this.defaultConfig_ = defaultConfig
    this.webosConfig_ = webosConfig

    // return this.initialize()
  }
  
  createDrmClient(drmType="widevine", appId=this.appId) {
    return new Promise(function(resolve, reject) { 
      webOS.service.request("luna://com.webos.service.drm", {
        method: "load",
        parameters: {
          "drmType": drmType,
          "appId": appId
        },
        onSuccess: function (response) {
          console.log("createDrmClient success", response)
          return resolve(response)
        },
        onFailure: function (error) {
          console.log("createDrmClient failed", error)
          console.log("[" + error.errorCode + "]: " + error.errorText)
          return reject(error)
        }
      })
    })
  }

  checkDrmClient(appId = this.appId) {
    return new Promise(function(resolve, reject) {
      webOS.service.request("luna://com.webos.service.drm", {
        method: "isLoaded",
        parameters: {
          "appId": appId
        },
        onSuccess: function (response) {
          console.log("checkDrmClient: " + JSON.stringify(response))
          return resolve(response)
        },
        onFailure: function (error) {
          console.log("checkDrmClient Failed to get DRM client loading state")
          console.log("[" + error.errorCode + "]: " + error.errorText)
          return reject(error)
        }
      })
    })
  }

  parseWidevinde() {
    const { drmMessage, messageType, drmSystemId } = this.widevineMessage(this.deviceId, this.manifestUrl_, licenseUrl, token)
  }

  async parsePlayready(clientId, licenseUrl, token) {
    await this.parseManifest(this.manifestUrl_).then((manifest) => {
      const { drmMessage, messageType, drmSystemId } = this.playreadyMessage(manifest, licenseUrl, token)
      this.sendRightInformation(clientId, messageType, drmMessage, drmSystemId)
    })
  }
  

  sendRightInformation(clientId, messageType, drmMessage, drmSystemId) {
    console.log("clientId =", clientId)
    return new Promise(function(resolve, reject) { 
      webOS.service.request("luna://com.webos.service.drm", { 
        method:"sendDrmMessage", 
        parameters: {
          "clientId": clientId,
          "msgType": messageType,
          "msg": drmMessage,
          "drmSystemId": drmSystemId
        }, 
        onSuccess: function (response) {
          // DRM API does not return the msgId, resultCode, resultMsg for Widevine type.
          console.log("sendDrmMessage succeeded")
          console.log(response)
          return resolve(response)
        },
        onFailure: function (error) {
          console.log("sendRightInformation failed", error)
          console.log("[" + error.errorCode + "] " + error.errorText)
          return reject(error)
        }
      })
    })
  }

  widevineMessage(deviceId = this.deviceId, manifestUrl = this.manifestUrl_, licenseUrl, token) {
    const drmMessage = `<?xml version="1.0" encoding="utf-8"?>
      <WidevineCredentialsInfo xmlns="http://www.smarttv-alliance.org/DRM/widevine/2012/protocols/" >'
      <ContentURL>'${manifestUrl} </ContentURL>'
      <DeviceID>' ${deviceId} </DeviceID>'
      <StreamID></StreamID>
      <ClientIP></ClientIP>
      <DRMServerURL> ${licenseUrl}</DRMServerURL>
      <DRMAckServerURL> </DRMAckServerURL>
      <DRMHeartBeatURL> </DRMHeartBeatURL>
      <DRMHeartBeatPeriod></DRMHeartBeatPeriod>
      <UserData></UserData>
      <Portal></Portal>
      <StoreFront></StoreFront>
      <BandwidthCheckURL></BandwidthCheckURL>
      <BandwidthCheckInterval></BandwidthCheckInterval>
      </WidevineCredentialsInfo>`
      ,messageType = 'application/widevine+xml'
      ,drmSystemId = 'urn:dvb:casystemid:19156'
    
    return { drmMessage, messageType, drmSystemId }
  }

  playreadyMessage(manifest, licenseUrl, token) {
    let xml = new DOMParser().parseFromString(manifest, 'application/xml')

    let videoAdaptationSet = xml.querySelector('AdaptationSet[mimeType="video/mp4"]')
    // let videoAdaptationSet = xml.querySelector('AdaptationSet[contentType="video/mp4"]')
    let pro = videoAdaptationSet.querySelector('pro')

    if (!pro || !pro.innerHTML) {
      console.warn("this manifest has not playready data");
      return
    }

    let decodedMessage =  window.atob(pro.innerHTML)
    let header = decodedMessage.split("").filter(this.isInvalidCharacter_).join("")

    header = header.replace(header.substring(header.indexOf('<LA_URL>')+8, header.lastIndexOf('</LA_URL>')), licenseUrl+'?token='+token)
    header = header.substring(header.indexOf('<WRMHEADER'), header.length)

    const drmMessage = '<?xml version="1.0" encoding="utf-8"?>'
      + '<PlayReadyInitiator xmlns="http://schemas.microsoft.com/DRM/2007/03/protocols/">'
      + '<LicenseAcquisition>'
      + '<Header>' + header + '</Header>'
      + '<SetCustomData>'
      + '<CustomData></CustomData>'
      + '</SetCustomData>'
      + '</LicenseAcquisition>'
      + '</PlayReadyInitiator>`'
    ,messageType = 'application/vnd.ms-playready.initiator+xml'
    ,drmSystemId = 'urn:dvb:casystemid:19219'

    return { drmMessage, messageType, drmSystemId }
  }

  /** @private */
  async parseManifest(manifestUrl) {
    return await fetch(manifestUrl).then((response) => response.text()).then((data) => data)
  }

  /** @private */
  isInvalidCharacter_(char) {
		let code = char.charCodeAt(0);
		let isUnwantedAsciiCode = code === 162;
		let isControlCode = code < 32
		return !isUnwantedAsciiCode && !isControlCode;
	}
}